import { HurdleNoteKinds } from "web_modules/Events/types";

export const getHurdleName = (eventKind: string): string => {
  const foundEnum = Object.entries(HurdleNoteKinds).find(([, value]) => value === eventKind) || [];
  return foundEnum[0] || null;
};
